import Swiper, { Navigation, Pagination, Autoplay, FreeMode, Thumbs } from "swiper";

export default class ComponentResorts {
    constructor() {

        this.section = document.querySelector('.component-resorts')

        this.sliders = this.section.querySelectorAll('.swiper--resort')
        this.slidersMobile = this.section.querySelectorAll('.swiper--resorts')

        // this.slider = document.querySelector(".swiper--component-resorts")
        // this.navigationPrev = document.querySelector(".slider-button-prev--component-resorts")
        // this.navigationNext = document.querySelector(".slider-button-next--component-resorts")

        // this.navigationPrevName = this.navigationPrev.querySelector('#namePrevSlide')
        // this.navigationNextName = this.navigationNext.querySelector('#nameNextSlide')

        // this.pagination = document.querySelector(".slider-pagination--component-resorts")
        
        // this.sliderGalerys = document.querySelectorAll(".swiper-gallery-resorts")
        // this.sliderGalerysThumbs = document.querySelectorAll(".swiper-gallery-resorts-thumbs")

        this.ready();
    }

    ready() {
        
        if(this.slidersMobile) {
            this.slidersMobile.forEach((sliderMobile, index) => {
                const swiper = new Swiper(sliderMobile, {
                    modules: [Navigation, Pagination],
                    grabCursor: true,
                    allowTouchMove: true,
                    navigation: {
                        nextEl: '.slider-button-next--resortMobile',
                        prevEl: '.slider-button-prev--resortMobile',
                    },
                    pagination: {
                        el: '.slider-pagination--resortMobile',
                        clickable: true,
                    },
                    slidesPerView: 1.25,
                    spaceBetween: 22,
                    slidesOffsetBefore: 22,
                    slidesOffsetAfter: 22,
                })
            })
        }

        if(this.sliders) {
            this.sliders.forEach((slider, index) => {
                const swiper = new Swiper(slider, {
                    modules: [Navigation, Pagination],
                    grabCursor: true,
                    allowTouchMove: true,
                    slidesPerView: 1,
                    navigation: {
                        nextEl: '.slider-button-next--resort-'+index,
                        prevEl: '.slider-button-prev--resort-'+index,
                    },
                    pagination: {
                        el: '.slider-pagination--resort-'+index,
                        clickable: true,
                    }
                })

            })
        }

        // const swiper = new Swiper(this.slider, {
        //     modules: [Navigation, Pagination],
        //     grabCursor: false,
        //     allowTouchMove: false,
        //     slidesPerView: 1,
        //     navigation: {
        //         nextEl: this.navigationNext,
        //         prevEl: this.navigationPrev
        //     },
        //     pagination: {
        //         el: this.pagination,
        //         clickable: true,
        //     },
        //     breakpoints: {
        //         0: {
        //             slidesPerView: 1.2,
        //             spaceBetween: 20,
        //             slidesOffsetBefore: 20,
        //             slidesOffsetAfter: 20,
        //         },
        //         768: {
        //             slidesPerView: 1,
        //             spaceBetween: 0,
        //             slidesOffsetBefore: 20,
        //             slidesOffsetAfter: 20,
        //         },
        //         1024: {
        //             slidesPerView: 1,
        //             spaceBetween: 0,
        //             slidesOffsetBefore: 0,
        //             slidesOffsetAfter: 0,
        //         },
        //     },
        //     on: {
        //         init: (swiper) => {
        //             if(this.slider.querySelector('.swiper-slide-next')) {
        //                 const currentTitle = this.slider.querySelector('.swiper-slide-active').dataset.title
        //                 this.navigationPrevName.innerHTML = currentTitle
        //                 const nextTitle = this.slider.querySelector('.swiper-slide-next').dataset.title
        //                 this.navigationNextName.innerHTML = nextTitle
        //             }
        //         },
        //     },
        // })

        // let swiperGalleryThumbs = []
        // if(this.sliderGalerysThumbs.length > 0 ) {
        //     this.sliderGalerysThumbs.forEach((sliderThumbs, index) => {
                
        //         // //Inicia slider de thumbs
        //         swiperGalleryThumbs[index] = new Swiper(sliderThumbs, {
        //             modules: [FreeMode],
        //             spaceBetween: 10,
        //             slidesPerView: 4,
        //             freeMode: true,
        //             grabCursor: true,
        //             watchSlidesProgress: true,
        //         })

        //     })
        // }
        
        // if(this.sliderGalerys.length > 0 ) {
        //     this.sliderGalerys.forEach((slider, index) => {

        //         //Inicia slider de fotos
        //         const swiperGallery = new Swiper(slider, {
        //             modules: [Navigation, Autoplay, Thumbs],
        //             grabCursor: true,
        //             allowTouchMove: true,
        //             slidesPerView: 1,
        //             autoplay: {
        //                 delay: 4000,
        //                 disableOnInteraction: false
        //               },
        //             thumbs: {
        //                 swiper: swiperGalleryThumbs[index],
        //             },
        //         })

        //     })
        // }

    }
}